module.exports = __webpack_public_path__ + "static/UNITY-TOWER-1st-floor-modern_v2-a9189bf88be97911f0537c5424d82619.pdf";